import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { getResourceCategories, createResourceCategory, resourceCategoryDetail, updateResourceCategory, deleteResourceCategory, showToast } from "../Utils/utils";
import ReactPaginate from 'react-paginate';
import { Col, Row, Dropdown, Modal } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'
import SweetAlert from "react-bootstrap-sweetalert";

const ResourceCategory = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [categoryList, setCategoryList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [categoryId, setCategoryId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [categoryName, setCategoryName] = useState("");
    const [categoryDescription, setCategoryDescription] = useState("");
    const [categoryType, setCategoryType] = useState("tile");
    const [categorySort, setCategorySort] = useState(null);
    const [categoryEditName, setCategoryEditName] = useState("");
    const [categoryEditType, setCategoryEditType] = useState("");
    const [categoryEditSort, setCategoryEditSort] = useState(null);
    const [categoryEditDescription, setCategoryEditDescription] = useState("");
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true);
            const limit = 10;
            const offset = page * limit;

            const response = await getResourceCategories({ search, limit, offset });

            if (response?.status == 200) {
                setCategoryList(response?.data?.rows);
                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch resources", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateCategory = async () => {
        try {
            setLoading(true);
            const body = {
                name: categoryName,
                description: categoryDescription,
                type: categoryType,
                sort: Number(categorySort),
            }

            const response = await createResourceCategory({ body });

            if (response?.status == 200) {
                fetchList()
                setShowCategoryModal(false)
                setCategoryName("")
                setCategoryDescription("")
                setCategorySort(null)
                showToast("Category added successfully", "success")
            } else {
                showToast(response?.data?.message || response?.data, "error")
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const handleUpdateCategory = async () => {
        try {
            setLoading(true);
            const body = {
                category_id: editingCategory.id,
                name: categoryEditName.trim(),
                description: categoryEditDescription.trim(),
                type: categoryEditType,
                sort: Number(categoryEditSort),
            };

            const response = await updateResourceCategory({ body });

            if (response?.status === 200) {
                showToast("Category updated", "success");

                setShowEditModal(false);
                setEditingCategory(null);

                fetchList();
            } else {
                showToast(response?.message || "Update failed", "error");
            }

        } catch (error) {
            showToast(error.message, "error");

        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        var res = await deleteResourceCategory(categoryId)
        if (res.status == 200) {
            showToast("Deleted successfully", "success");
            fetchList();
        }
        setShowAlert(false);
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />

                        <div className="header header-bg pb-6">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row align-items-center py-4">
                                        <div className="col-lg-6 col-7">
                                            <nav
                                                aria-label="breadcrumb"
                                                className="d-none d-md-inline-block ml-md-4"
                                            >
                                                <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                    <li className="breadcrumb-item">
                                                        <Link to="/dashboard">
                                                            <i className="fas fa-home" />
                                                        </Link>
                                                    </li>
                                                    <li className="breadcrumb-item mt-2">
                                                        <span className="" style={{ color: "#f6f9fc" }}>Resource Category</span>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Resources Category</h5>
                                                    <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content="A complete list of all resources available on the platform. Use this section to review resource details, manage visibility, track engagement metrics, and ensure content accuracy."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />

                                                    </p>

                                                    <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                    <button className="export-btn" onClick={() => setShowCategoryModal(true)}> Create Category </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Description</th>
                                                        <th>Type</th>
                                                        <th>Sort</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {categoryList?.length > 0 ? (
                                                        categoryList.map((category, index) => (
                                                            <tr key={index}>
                                                                <td>{category?.name}</td>
                                                                <td>
                                                                    <span className="truncate-text">
                                                                        {category?.description}
                                                                    </span>
                                                                </td>
                                                                <td>{category?.type}</td>
                                                                <td>{category?.sort}</td>
                                                                <td style={{ width: "160px" }}>
                                                                    <button
                                                                        className="viewproject-btn pull-right mb-1"
                                                                        onClick={() => {
                                                                            setEditingCategory(category);
                                                                            setCategoryEditName(category?.name);
                                                                            setCategoryEditType(category?.type || "");
                                                                            setCategoryEditSort(category?.sort || null);
                                                                            setCategoryEditDescription(category?.description || "");
                                                                            setShowEditModal(true);
                                                                        }}
                                                                    >
                                                                        <span className="text-white">Edit</span>
                                                                    </button>
                                                                    <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                        setCategoryId(category?.id)
                                                                        setShowAlert(true)
                                                                    }} >
                                                                        <span className="text-white">Delete</span>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                    <Modal
                        show={showCategoryModal}
                        onHide={() => setShowCategoryModal(false)}
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Create Category</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter category name"
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                            />
                            <textarea
                                className="form-control mt-2"
                                placeholder="Enter category description"
                                rows={4}
                                value={categoryDescription}
                                onChange={(e) => setCategoryDescription(e.target.value)}
                            />
                            <div className="d-flex gap-1 align-items-center my-2">
                                <label>
                                    Category View Type
                                </label>
                                <select
                                    className="custom-select-dropdown font-bold"
                                    value={categoryType}
                                    onChange={(e) => setCategoryType(e.target.value)}
                                >
                                    <option value="tile" className='option'>Tile</option>
                                    <option value="carousel" className='option'>Carousel</option>
                                    <option value="listing" className='option'>Listing</option>
                                </select>
                            </div>
                            <input
                                type="number"
                                placeholder="Enter order number"
                                className="form-control"
                                value={categorySort}
                                onChange={(e) => setCategorySort(e.target.value)}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => setShowCategoryModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn primary-action-btn"
                                disabled={!categoryName.trim()}
                                onClick={handleCreateCategory}
                            >
                                Save
                            </button>
                        </Modal.Footer>
                    </Modal>
                    <Modal
                        show={showEditModal}
                        onHide={() => setShowEditModal(false)}
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Category</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <input
                                type="text"
                                className="form-control"
                                value={categoryEditName}
                                onChange={(e) => setCategoryEditName(e.target.value)}
                            />

                            <textarea
                                className="form-control mt-2"
                                rows={4}
                                value={categoryEditDescription}
                                onChange={(e) => setCategoryEditDescription(e.target.value)}
                            />
                            <div className="d-flex gap-1 align-items-center my-2">
                                <label>
                                    Category View Type
                                </label>
                                <select
                                    className="custom-select-dropdown font-bold"
                                    value={categoryEditType}
                                    onChange={(e) => setCategoryEditType(e.target.value)}
                                >
                                    <option value="tile" className='option'>Tile</option>
                                    <option value="carousel" className='option'>Carousel</option>
                                    <option value="listing" className='option'>Listing</option>
                                </select>
                            </div>
                            <input
                                type="number"
                                className="form-control"
                                value={categoryEditSort}
                                onChange={(e) => setCategoryEditSort(e.target.value)}
                            />
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={() => setShowEditModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn primary-action-btn"
                                disabled={!categoryEditName.trim()}
                                onClick={handleUpdateCategory}
                            >
                                Update
                            </button>
                        </Modal.Footer>
                    </Modal>
                    {showAlert && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="secondary"
                            title="Are you sure?"
                            onConfirm={handleDelete}
                            onCancel={() => setShowAlert(false)}
                            focusCancelBtn
                        >
                            This action cannot be undone.
                        </SweetAlert>
                    )}
                </div>
            </div>
        </>

    )
}
export default ResourceCategory;